module.exports = __webpack_public_path__ + "img/whatsapp.b253c5bf.gif";